var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',[_c('vnt-header',[_vm._v("Edit item")]),_c('item-form',{attrs:{"year":_vm.year,"month":_vm.month,"itemId":_vm.itemId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }